import { AnimatePresence, m } from 'framer-motion';
import { randomId } from '@shared/utils/randomId.js';
import Portal from '@/components/Portal.jsx';
import DividerV2 from '@/components/v2/DividerV2.jsx';

const FloatingMenu = ({ className = '', show = false, children, leftContent, rightContent }) => {
  const id = `floating-menu-${randomId()}`;

  return (
    <Portal id={id}>
      <AnimatePresence>
        {show && (
          <m.div
            className={`comp-floating-menu ${className}`} //
            initial={{ opacity: 0, y: 50, translateX: '-50%', translateY: '-50%' }}
            animate={{ opacity: 1, y: 0, translateX: '-50%', translateY: '0' }}
            exit={{ opacity: 0, y: 50, translateX: '-50%', translateY: '-50%' }}
            transition={{ type: 'spring', duration: 0.15, bounce: 0 }}>
            {leftContent}
            {leftContent && <DividerV2 mode={'vertical'} />}
            {children}
            {rightContent && <DividerV2 mode={'vertical'} />}
            {rightContent}
          </m.div>
        )}
      </AnimatePresence>
    </Portal>
  );
};

export default FloatingMenu;
